// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"28b1bf35","831":"f69afe55"}[chunkId] + ".chunk.js";
};